import { getAutomationsRouteContext } from '@/lib/automations/automationRoutes.js';
import getNormalizedThreadId from '@/redux/selectors/pieveSelectors/lib/getNormalizedThreadId.js';

const getCurrentAutomationRunThreadId = ({ pathname, routeRunThreadId, currentOwnerId, selectionContext, automationType, selectionOwnerKey }) => {
  const routeContext = getAutomationsRouteContext(pathname);
  const normalizedRouteRunThreadId = getNormalizedThreadId(routeRunThreadId);
  const normalizedRouteOwnerId = routeContext?.type === automationType ? String(routeContext?.id || '').trim() : '';

  if (normalizedRouteOwnerId && !routeContext?.isEdit && normalizedRouteRunThreadId) {
    return normalizedRouteRunThreadId;
  }

  const normalizedContextRunThreadId = getNormalizedThreadId(selectionContext?.runThreadId);
  const normalizedContextOwnerId = String(selectionContext?.[selectionOwnerKey] || '').trim();

  if (!normalizedContextRunThreadId) {
    return null;
  }

  const normalizedActiveOwnerId = normalizedRouteOwnerId || String(currentOwnerId || '').trim();

  if (normalizedActiveOwnerId && normalizedContextOwnerId && normalizedActiveOwnerId !== normalizedContextOwnerId) {
    return null;
  }

  return normalizedContextRunThreadId;
};

export default getCurrentAutomationRunThreadId;
